import React from 'react';
import { useTranslation } from 'react-i18next';
import { GaugeChart } from '@fluentui/react-charting';
import './GaugeFluentWidget.css';

const GaugeFluentWidget = ({ data, config }) => {
    const { t } = useTranslation();

    console.log('📊 GaugeFluentWidget received:', { data, config });

    // Extract configuration
    const minValue = config?.config?.minValue || config?.minValue || 0;
    const maxKey = config?.config?.maxKey || config?.maxKey || 'maxValue';
    const targetKey = config?.config?.targetKey || config?.targetKey || 'targetValue';
    const currentKey = config?.config?.currentKey || config?.currentKey || 'currentValue';
    const format = config?.config?.format || config?.format || 'number';

    // Extract values from data
    const currentValue = data?.[currentKey] || 0;
    const targetValue = data?.[targetKey] || 100;
    const maxValue = data?.[maxKey] || 150;

    // Format value based on format type
    const formatValue = (value) => {
        if (format === 'duration') {
            const totalSeconds = Math.round(value);
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            return `${minutes}:${seconds.toString().padStart(2, '0')}`;
        }
        return Math.round(value).toString();
    };

    // Calculate percentage for gauge (current vs max)
    const percentage = Math.min(100, (currentValue / maxValue) * 100);

    // Determine segments based on target and max
    const segments = [
        {
            legend: t('WITHIN_TARGET') || 'Within Target',
            size: (targetValue / maxValue) * 100,
            color: '#107C10' // Green
        },
        {
            legend: t('APPROACHING_MAX') || 'Approaching Max',
            size: ((maxValue - targetValue) / maxValue) * 100,
            color: '#FFB900' // Yellow
        }
    ];

    const chartData = {
        chartTitle: t(config?.titleKey || config?.title) || 'Gauge',
        chartValue: currentValue,
        chartValueFormat: formatValue(currentValue),
        segments: segments
    };

    return (
        <div className="gauge-fluent-widget">
            <div className="gauge-container-fluent">
                <GaugeChart
                    width={280}
                    height={200}
                    segments={segments}
                    chartValue={percentage}
                    chartValueFormat={() => formatValue(currentValue)}
                    sublabel={`${t('TARGET')}: ${formatValue(targetValue)} | ${t('MAX')}: ${formatValue(maxValue)}`}
                    hideMinMax={true}
                />
            </div>
            <div className="gauge-info">
                <div className="gauge-stat">
                    <span className="gauge-stat-label">{t('CURRENT')}:</span>
                    <span className="gauge-stat-value">{formatValue(currentValue)}</span>
                </div>
                <div className="gauge-stat">
                    <span className="gauge-stat-label">{t('TARGET')}:</span>
                    <span className="gauge-stat-value target">{formatValue(targetValue)}</span>
                </div>
                <div className="gauge-stat">
                    <span className="gauge-stat-label">{t('MAX')}:</span>
                    <span className="gauge-stat-value max">{formatValue(maxValue)}</span>
                </div>
            </div>
        </div>
    );
};

export default GaugeFluentWidget;
